import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import {renderToStaticMarkup} from "react-dom/server";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import React from "react";

export const userAsAdmin = (selectedRow) => {

  const kmo = selectedRow.getData().KMO
  //debugger
  const temp = _axios
    .get(prefixUrl() + '/permissions/?request=defineUserAccess&userKMO=' + kmo)
    .then((response) => {
      let data = response.data;
      showSweetAlertModal(data.hasAccess, kmo)

    })
    .catch((error) => {
      toast.error(error);
    });
  //

}


const showSweetAlertModal = (hasAccess: boolean, kmo: string) => {

  const htmlString = renderToStaticMarkup(
    <>
      <div>
        <div
          // className={"d-flex flex-wrap w-100 "}
          // style={{padding: "0 3em"}}
        >

          <div
            className="form-check00 text-end d-flex"
            // style={{width: "90%"}}
          >
            <div>
              <input
                className="form-check-input user__as__admin"
                type="checkbox"
                id={kmo}
                checked={hasAccess}
              />
            </div>
            <label className="form-check-label " htmlFor={kmo}>
              امکان تعریف کاربر، تعیین سطح دسترسی کاربران و «فعال و غیر فعال کردن کاربران» برای {kmo}
            </label>
          </div>
        </div>
      </div>
    </>
  );

  Swal.fire({
    title: "دسترسی مدیر",
    html: htmlString,
    confirmButtonText: "تایید",
    cancelButtonText: "لغو",
    focusConfirm: false,
    showCancelButton: true,
    showCloseButton: true,
    preConfirm: () => {
      const isChecked = Swal.getPopup().querySelector(".user__as__admin").checked;
      return {
        hasAccess: isChecked
      }
    },
  }).then((result) => {

    const {hasAccess} = result.value;
    const requestToSubmit = _axios.post(prefixUrl() + '/permissions/?request=setDefineUserAccess', {
      userKMO: kmo,
      hasAccess: hasAccess
    })
      .then((response) => {
        if (response.data.status) {
          toast.success(response.data.message);
          // setNeedToReloadTable((prevState) => !prevState);

        } else {
          toast.error(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    toast.promise(requestToSubmit, {
      pending: "در حال ثبت...",
      // success: "کاربر به لیست اضافه شد.",
      error: "درخواست با مشکل رو به رو شد.",
    });
  });


}


